export default __webpack_public_path__ + "images/a26c097428d5f2c0f3cf84938f9d1da2-bushs_beans_mobile.webp";